export default __webpack_public_path__ + "images/a3a60fc44541c4a6ee2a86f0ac816380.svg";